import React from 'react';
import PropTypes from 'prop-types';

class StyledHeader extends React.Component {

  render() {
    const {
      content,
    } = this.props.block;

    return (
      <div className="StyledHeader container u-vSpacingMD-top">
        <div className="row">
          <div className={content.contentClassName}>
            <h1 className="h2">{content.title}</h1>
            <div
              className="StyledHeader-description"
              dangerouslySetInnerHTML={{ __html: content.description }} />
          </div>
        </div>
      </div>
    );
  }
}

StyledHeader.propTypes = {
  block: PropTypes.shape({
    content: PropTypes.shape({ }),
    config: PropTypes.shape({ }),
  }),
};

export default StyledHeader;
